module.exports = __webpack_public_path__ + "assets/php.28fec702.svg";